/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The selectors for widget components
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */
import get from 'lodash/get';
import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../reducers/rootReducer';
import { widgetInitialState } from './widgetReducer';
import { IWidgetReducerState, TWidgetMetaList } from './widgetTypes';

export const makeSelectorWidgetState = (state: IRootReducer): IWidgetReducerState =>
    get(state, 'dashboard.widgetReducer', widgetInitialState);

export const makeSelectorWidgetMetaList =
    (): OutputSelector<IRootReducer, TWidgetMetaList, (state: IWidgetReducerState) => TWidgetMetaList> =>
    createSelector(
        makeSelectorWidgetState,
        (state: IWidgetReducerState) => get(state, 'widgetMeta', []),
    );

export const makeSelectorWidgetEmptyList =
    (): OutputSelector<IRootReducer, boolean, (state: IWidgetReducerState) => boolean> =>
    createSelector(
        makeSelectorWidgetState,
        (state: IWidgetReducerState) => get(state, 'emptyWidgets', false),
    );
